import { Component, OnInit, HostListener, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '../_services/loader.service';
import { GridOption } from 'src/app/_models/gridoptions.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {
  @ViewChild('authModal', {static: false}) editModal: TemplateRef<any>; // Note: TemplateRef
  // currentUser: any;
  device: any;
  search: any;
  list: any = [];
  gridOption: GridOption = {
    pageTitle: 'select Page',
    page: 0,
    pagesize: 2,
    total: 0,
    order: '-_id',
    search: '',
    sortField: '',
    sortOrder: '',
    skip: 0,
    limit: 6,
    random: true,
    filter: {parent_id: '', status: 1},
    allrecords: false,
  };
  topiclist: any;
  loaddata = false;

  constructor(
    private router: Router,
    public loaderService: LoaderService,
  ) {   }

  ngOnInit() {
    // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    window.scrollTo(0, 0);
    this.device = window.innerWidth;
      }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.device = event.target.innerWidth;
  }

  onSearch(event: any) {}

}
